import { NavigationGuard } from 'vue-router'

import store from '@/store'

export const checkPro: NavigationGuard = (to, from, next): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (store.getters['profile/plan'] == 'pro') {
      resolve()
    } else {
      next({ name: 'Home' })
      reject()
    }
  })
}

export const checkProBusiness: NavigationGuard = (to, from, next): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (store.getters['profile/plan'] == 'pro' || store.getters['profile/plan'] == 'business') {
      resolve()
    } else {
      next({ name: 'Home' })
      reject()
    }
  })
}


// Проверить авторизирован ли пользователь (есть ли токен)
  // Нет - перебросить на авторизацию
  // Да - перейти на требуемую страницу

export const checkNotAuthenticated: NavigationGuard = (to, from, next): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!store.getters['auth/isAuthenticated']) {
      resolve()
    } else {
      next({ name: 'Home' })
      reject()
    }
  })
}

export const checkAuthenticated: NavigationGuard = (to, from, next): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (store.getters['auth/isAuthenticated']) {
      resolve()
    } else {
      next({ name: 'Signin' })
      reject()
    }
  })
}

export const checkAdmin: NavigationGuard = (to, from, next): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (true) { // if admin goto Localization
      next({ name: 'Localization' })
      resolve()
    } else {
      next({ name: 'Product' })
      reject()
    }
  })
}
